import type { ModuleNav } from '@saas/ui';

export const PROFILE_READ = ['company-profile.profile.read'];

/**
 * company-profile のメニュー。企業プロファイル本体は顧客一覧（crm）から開く 1 画面なので、
 * メニューには「危険のある顧客」の一覧だけを出す（管理メニューは無い）
 */
export const companyProfileNav: ModuleNav = {
  module: 'company-profile',
  items: [{ label: '企業プロファイル', to: '/company-profile', icon: 'business', end: true, permission: PROFILE_READ, description: '解約通知期限・決裁者への到達・粗利の悪化。危険のある顧客から開く' }],
  admin: [],
};
